const TrendingPostSkeletonV2 = ({ viewRef }: any) => {
  return (
    <div className="my-5" ref={viewRef}>
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="mt-2.5 overflow-hidden ml-5">
        <div className="w-[477px] flex flex-row items-center ">
          {new Array(3).fill(0).map((_item, index) => {
            return (
              <div key={`trend-post-skeleton-${index}`} className="w-[128px] ml-2.5 first:ml-0">
                <div className=" h-[170px] rounded-400 bg-surface-200-bg skeleton" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendingPostSkeletonV2;
